import {Textarea } from "@mantine/core";

const MantineTextArea = (props: any) => {
  const { label, placeholder, value, onChange, error, classNames, disabled, rightSection, leftSection,style } = props;
  return (
    <Textarea
      classNames={classNames}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      rightSection={rightSection}
      leftSection={leftSection}
      autoComplete="off"
      style={style}
    />
  );
};

export default MantineTextArea;
